// Uses the environment variable if deployed, otherwise defaults to localhost for development
// const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8080";

const API_BASE_URL = process.env.REACT_APP_API_URL || "https://chitra.setuschool.com/chitra-apis/";

export default API_BASE_URL;